import React, {useState, Fragment } from 'react';
import {Col,Row, Container, Button} from 'react-bootstrap';
import classes from '../../WebsiteManagement/websiteManagement.module.css';
import classesX from '../../Dashboard/dashboard.module.css'
import HolidayBookingDetails from './HolidayBookingDetails';
import HolidayCustomerDetails from './HolidayCustomerDetails';
import HolidayBillingDetails from './HolidayBillingDetails';
const HolidayDetails = (props)=>{
    const [active,updateActive] = useState('1');
    const items = [
        {id:"1",type:"Booking Details"},
        {id:"2",type:"Customer Details"},
        {id:"3",type:"Cancellation Details"},
        {id:"4",type:"Billing Details"}
      
    ]
 
    return(
        <Fragment> 
            <h1 className={classesX.Heading}>Holiday Details</h1>
            {props.clicked ? (
              <div style={{ marginBottom: 16 }}>
                <Button variant="secondary" onClick={props.clicked}>Back to list</Button>
              </div>
            ) : null}
       
<Container fluid style={{ paddingLeft: '10px', width: '90%' }}>
    <Row>
        <Col lg={12} md={12} className={classes.Response2}>
            <div style={{ height: '100%' }}>
                <ul className={classes.Ul} style={{ display: 'flex', flexDirection: 'row', listStyle: 'none', padding: 0 }}>
                    {
                        items.map(item => (
                            <li
                                key={item.id}
                                onClick={() => updateActive(item.id)}
                                className={classes.Li}
                                style={{
                                    backgroundColor: `${active === item.id ? 'steelblue' : '#585858'}`,
                                    textAlign: 'center',
                                    margin: '0 1px', // Adjust the margin as needed
                                    padding:" 2% 0",
                                    color: 'white',
                                    cursor: 'pointer',
                                    width:"25%",
                                    height:"100%"
                                }}
                            >
                                {item.type}
                            </li>
                        ))
                    }
                </ul>
            </div>
        </Col>
        <Col lg={12} md={12} className={classes.Response}>
            <div style={{ height: '100%' }}>
            {
                active === "1" ? (
                    <HolidayBookingDetails booking={props.data}/>
                ) : active === "2" ? (
                    <HolidayCustomerDetails booking={props.data}/>
                ) : active == "3" ? (
                  null
                ) : active == "4" ? (
                 <HolidayBillingDetails booking={props.data}/>
                ) : null
                // active==="3"?<CouponView data={couponData}/>:null
              }
            </div>
        </Col>
    </Row>
</Container>

        </Fragment>
    )
}

export default HolidayDetails;